import { Injectable } from '@angular/core';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { Observable, of } from 'rxjs';
import { SelectItem } from '@web/shared/ui';
import { PublicIssueComplaintType } from '../enums/public-issue-complaint-type';

@Injectable({
  providedIn: 'root',
})
export class PublicIssueComplaintTypeProviderService {
  private readonly entries = new Map<PublicIssueComplaintType, string>([
    [PublicIssueComplaintType.DefectiveProduct, 'Uszkodzony produkt'],
    [PublicIssueComplaintType.NoProduct, 'Brak produktu'],
    [PublicIssueComplaintType.Other, 'Inny powód'],
  ]);

  public labelFor(type: PublicIssueComplaintType): Observable<string> {
    const entry = this.entries.get(type);

    if (isNil(entry)) {
      throw new EntryNotFoundException(`The entry for "${type}" is not found.`);
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<PublicIssueComplaintType>[]> {
    const result = Array.from(this.entries.entries()).map(
      ([type, label]) => new SelectItem(label, type),
    );

    return of(result);
  }
}
